import { render, staticRenderFns } from "./Util-Add.vue?vue&type=template&id=536cddb9"
import script from "./Util-Add.vue?vue&type=script&lang=js"
export * from "./Util-Add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports